import { render } from "./AddPropertySidepanel.vue?vue&type=template&id=51043f28&scoped=true"
import script from "./AddPropertySidepanel.vue?vue&type=script&lang=js"
export * from "./AddPropertySidepanel.vue?vue&type=script&lang=js"

import "./AddPropertySidepanel.vue?vue&type=style&index=0&id=51043f28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51043f28"]])

export default __exports__